export const SELECT_AWAITING_AUTH_TAB = 'SELECT_AWAITING_AUTH_TAB';
export const SHOW_MY_BATCH = 'SHOW_MY_BATCH';
export const HIDE_MY_BATCH = 'HIDE_MY_BATCH';
export const SHOW_OTHER_USER_BATCH = 'SHOW_OTHER_USER_BATCH';
export const HIDE_OTHER_USER_BATCH = 'HIDE_OTHER_USER_BATCH';
export const CHANGE_MY_PAYMENTS_SORT = 'CHANGE_MY_PAYMENTS_SORT';
export const CHANGE_OTHER_USER_PAYMENTS_SORT = 'CHANGE_OTHER_USER_PAYMENTS_SORT';
export const SELECT_TO_AUTHORISE = 'SELECT_TO_AUTHORISE';
export const SELECT_TO_VIEW = 'SELECT_TO_VIEW';
export const SELECT_TO_EDIT = 'SELECT_TO_EDIT';
export const HIDE_EXPIRED_PAYMENTS = 'HIDE_EXPIRED_PAYMENTS';

export const selectAwaitingAuthTab = (activeAwaitingAuthTab) => ({
	type: SELECT_AWAITING_AUTH_TAB,
	activeAwaitingAuthTab,
});

export const showMyBatch = (batchId) => ({ type: SHOW_MY_BATCH, batchId });

export const hideMyBatch = (batchId) => ({ type: HIDE_MY_BATCH, batchId });

export const showOtherUserBatch = (batchId) => ({ type: SHOW_OTHER_USER_BATCH, batchId });

export const hideOtherUserBatch = (batchId) => ({ type: HIDE_OTHER_USER_BATCH, batchId });

export const updateMyPaymentsSortColumn = (myPaymentsSortColumn) => ({
	type: CHANGE_MY_PAYMENTS_SORT,
	myPaymentsSortColumn,
});

export const updateOtherUserPaymentsSortColumn = (otherUserPaymentsSortColumn) => ({
	type: CHANGE_OTHER_USER_PAYMENTS_SORT,
	otherUserPaymentsSortColumn,
});

export const selectToAuthorise = (toAuthorise) => ({
	type: SELECT_TO_AUTHORISE,
	toAuthorise,
});

export const selectToView = (toView) => ({
	type: SELECT_TO_VIEW,
	toView,
});

export const selectToEdit = (toEdit) => ({
	type: SELECT_TO_EDIT,
	toEdit,
});

export const hideExpired = () => ({ type: HIDE_EXPIRED_PAYMENTS });
